import { useNavigate } from 'react-router-dom'
import { Heading } from '../../../../Components/Screen/Text/Heading'
import { Text } from '../../../../Components/Screen/Text/Body'

export const RelatedArts = (props) => {
  const { arts, art } = props
  const relatedArts = arts
    ?.filter((a) => a?.userId === art?.userId)
    .filter((a) => a?.withoutqr !== art?.withoutqr)
  const navigate = useNavigate()
  const handleInfos = (art) => {
    navigate(`/farms/${art?.car}`, {
      state: { art, arts },
    })
  }

  return relatedArts?.length > 0 ? (
    <section id="daily" className="w-full py-12 text-left flex flex-col gap-6">
      <Heading>Outras fazendas do proprietário</Heading>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
        {relatedArts?.map((a, index) => (
          <div
            key={index}
            className="cursor-pointer relative w-full h-64 rounded overflow-hidden group"
            onClick={() => handleInfos(a)}
          >
            <img
              src={a?.withoutqr}
              alt="art"
              className="object-cover w-full h-full group-hover:scale-105 transition-transform duration-300"
              loading="lazy"
            />
            <div className="flex justify-between h-16 w-full p-2 absolute bottom-0 left-0 bg-cinzaescuro bg-opacity-70 backdrop-blur items-center">
              <Text className="text-branco truncate">{a?.name}</Text>
            </div>
          </div>
        ))}
      </div>
    </section>
  ) : (
    <section id="daily" className="w-full py-12 text-left flex flex-col gap-4">
      <Heading>Outras fazendas do proprietário</Heading>
      <Text className={'text-info'}>Não foram encontradas fazendas.</Text>
    </section>
  )
}
